import { HttpResponse } from '@angular/common/http';
import { Component, ElementRef, Inject, OnInit, ViewChild } from '@angular/core';
import { FormControl, FormGroup, Validators } from '@angular/forms';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import moment from 'moment';
import { tap } from 'rxjs/operators';
import { DriverTask } from 'src/app/classes/driver-task';
import { EndDeleteTaskPayload } from 'src/app/classes/end-delete-task';
import { EventsDeltaService } from 'src/app/services/events-delta.service';
import { EventsService } from 'src/app/services/events.service';
import { LoggerService } from 'src/app/services/logger.service';
import { MyTasksService } from 'src/app/services/my-tasks.service';
import { ProfileService } from 'src/app/services/profile.service';
import { ToastService } from 'src/app/services/toast.service';

export interface DialogData {
  driverTask: DriverTask;
}

@Component({
  standalone: false,
  selector: 'app-end-task-reason-dialog',
  templateUrl: './end-task-reason-dialog.component.html',
  styleUrls: ['./end-task-reason-dialog.component.scss']
})
export class EndTaskReasonDialogComponent implements OnInit {
  @ViewChild('notes', { static: false }) notesElement: ElementRef;
  endOrDeleteReasons: any;

  constructor(
    public dialogRef: MatDialogRef<EndTaskReasonDialogComponent>,
    @Inject(MAT_DIALOG_DATA) public data: DialogData,
    private eventsService: EventsService,
    private eventsDeltaService: EventsDeltaService,
    private myTasksService: MyTasksService,
    private logger: LoggerService,
    private toastService: ToastService,
    private profileService: ProfileService,
    private el: ElementRef
  ) { }

  form = new FormGroup({
    reasonRadio: new FormControl('', Validators.required),
    notes: new FormControl('')
  });

  get f(){
    return this.form.controls;
  }

  ngOnInit(): void {
    this.endOrDeleteReasons = this.getReasons();
  }

  getReasons(): string[]{
    const reasons = JSON.parse(this.eventsService.eventData$.getValue().uiParameters.TASK_UNASSIGNMENT_LIST);
    reasons.push('Other');
    return reasons;
  }

  submit(){
    const payload: EndDeleteTaskPayload = {
      deleteBy: this.profileService.profileObs$.getValue().adId,
      driverNote: this.form.value.notes,
      taskId: this.data.driverTask.taskName,
      timeStamp: moment().toISOString(),
      type: 'endTask'
    };
    this.myTasksService.endOrDeleteTask(payload)
    .pipe(tap(() => this.eventsDeltaService.getDeltas()))
    .subscribe((resp:HttpResponse<any>) => {
      this.logger.debug(`PUT End task response:`, resp, 'http');
       if(resp.status === 204){
        this.toastService.show(`Success: The task was ended`, { classname: 'bg-success text-light', delay: 4000 });
        this.dialogRef.close(true);
      }else{
        this.toastService.show(`Error ${resp.status} occurred processing task`, { classname: 'bg-danger text-light', delay: 4000 });
      }
    });
  }

  isNoteRequired(): boolean{
    if(this.f.reasonRadio.touched && this.f.reasonRadio.value === 'Other' && this.f.notes.value.length < 3){
     this.notesElement.nativeElement.focus();
      return true;
    }else{
      return false;
    }
  }


}
